/* eslint-disable camelcase */
module.exports = function (self) {
	return {
		async list(offset = 0, limit = self.limit) {
			try {
				const response = await self.$http.get(
					'admin/comments', {
						params: {
							offset,
							limit,
						},
						headers: {
							Authorization: true,
						},
					},
				);

				const deals = {
					total: response.data.comments.total,
					results: response.data.comments.results,
				};

				return {
					ok: true,
					data: deals,
					error: null,
				};
			} catch (error) {
				return {
					ok: false,
					data: [],
					error: null,
				};
			}
		},
	};
};
